import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';

@Injectable({
  providedIn: 'root'
})

export class SiteContentService {

  public siteContent: any;

  constructor(
    private config: ConfigService,
    private http: HttpClient
  ){
    this.siteContent = new Map();
  }

  public loadConfig(pageName: string): Promise<SiteContentInterface | any> {
    return new Promise((resolve) => {
      if(this.siteContent.has(pageName)){
        resolve(this.siteContent.get(pageName));
      } 
      else {
        const fileUrl = this.getCDNAssetPath("site_content/" + pageName) + '.config?v=' + new Date().getTime();
        this.http.get<SiteContentInterface>(fileUrl).subscribe({
          next: (response: any) => {
            if (response != null) {
              this.siteContent.set(pageName, response);
              resolve(response);
            }
          },
          error: () => {
            console.warn('Site content not loading from CDN for', pageName);

            const localPath = "/assets/site_content/" + pageName + '.config';
            this.http.get(localPath).subscribe((res: any) => {
              if (res != null) {
                this.siteContent.set(pageName, res);
                resolve(res);
              }
            });
          },
          complete: () => {

          }
        });
      }
    });
  }

  private getCDNAssetPath(path): string {
    const cdnBaseURL = this.config.getConfig().CDN_BASEURL;
    if (undefined !== path) {
      if (undefined !== typeof cdnBaseURL) {
        return cdnBaseURL + "/assets/" + path;
      }
      return "";
    }
  }
}